import { useSelector } from 'react-redux';
import { useAppSelector } from '../reducers';
import { experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../selectors/ExperimentSelectors';
import { MC0655_TREATMENT_KEY, MC0655_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys';
export const useMC0655Data = () => {
  const mc0655Data = useAppSelector(state => experimentByTreatmentKeySelector(state, MC0655_TREATMENT_KEY));
  const mc0655Cohort = mc0655Data && mc0655Data.parameters && mc0655Data.parameters.group;
  const hasExperimentsFetchSucceeded = useSelector(hasExperimentsFetchSucceededSelector);
  return {
    isInMC0655Variant: mc0655Cohort === MC0655_GROUP_PARAMETER_OPTIONS.variant,
    hasExperimentsFetchSucceeded
  };
};